var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('nav',{staticClass:"navbar navbar-expand-lg bg-white"},[_c('div',{staticClass:"container"},[_c('router-link',{attrs:{"to":{name:'home'}}},[_c('img',{attrs:{"src":"img/dtaccall-nav-icon.png","height":"48"}})])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }